import { ICampaign } from 'src/shared/models';

export const getTimeFormat = (mili: number) => {
  const days = Math.floor(mili / (1000 * 60 * 60 * 24));
  let remainingMilliseconds = mili - days * (1000 * 60 * 60 * 24);

  const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
  remainingMilliseconds = remainingMilliseconds - hours * (1000 * 60 * 60);

  const minutes = Math.floor(remainingMilliseconds / (1000 * 60));
  remainingMilliseconds = remainingMilliseconds - minutes * (1000 * 60);

  const seconds = Math.floor(remainingMilliseconds / 1000);

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

export const getDiffInMiliseconds = (campaign: ICampaign): number => {
  if (!campaign) return 0;
  const date = new Date();
  const expirationDate = new Date(campaign.expirationDate);
  return expirationDate.getTime() - date.getTime();
};
